import Navbar from "../components/Navbar.jsx";
import MFcomplete from "../assets/MindFood_Complete2.svg";
import cajuWallpaper from "../assets/cajuWallpaper.svg";

export default function Home() {
  const Main = {
    backgroundImage: `url(${cajuWallpaper})`,
    backgroundSize: "cover",
    height: "100vh",
  };
  const Slogan = {
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 1)",
    borderRadius: "12px",
    height: "40%",
    marginLeft: "37%",
    marginTop: "3%",
  };
  return (
    <>
      <div className="main" style={Main}>
        <Navbar />
        <img
          src={MFcomplete}
          style={Slogan}
          alt="MindFood - Be Mindful When Consume"
        />
      </div>
    </>
  );
}
